import axios from 'axios'
import { URLS } from '../../util/urls'
import debugHelper from '../../util/debug'
import tools from '../../util/tools'
import msgbus from '../../msgBus'

const state = {
  appDispVersion: '', // app用于显示的版本信息（apk版本号 + H5版本号）
  isUpdateVersion: false, // 标识是否更新版本
  updateProgressPre: 0, // 更新下载的进度

  /**
   * app信息
   */
  release: {
    data: {
      id: null,
      tid: null,
      createAt: null,
      updateAt: null,
      appOID: null,
      productName: null,
      productVer: null,
      appName: null,
      appVer: null,
      notes: null,
      attachments: [{
        name: null,
        uri: ''
      }]
    },
    status: 200
  }
}

const getters = {
  getAppDispVersion: state => {
    return state.appDispVersion
  },
  getIsUpdateVersion: state => {
    return state.isUpdateVersion
  },
  getAppServerVersion: state => {
    if (state.release.data) {
      return state.release.data.appVer
    } else {
      return null
    }
  },
  getAppDownloadUrl: state => {
    if (
      state.release.data &&
      state.release.data.attachments &&
      state.release.data.attachments.length
    ) {
      return state.release.data.attachments[0].uri || ''
    } else {
      return null
    }
  },
  getUpdateProgressPre: state => {
    return state.updateProgressPre
  },
}

const actions = {
  checkAndroidAppVersion: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: URLS.EDS_CHECK_VER_URL,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('checkAppVersionSucc', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'update:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  checkIOSAppVersion: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: URLS.EDS_CHECK_IOSVER_URL,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('checkAppVersionSucc', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'update:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

}

const mutations = {
  setAppDispVersion: (state, payload) => {
    state.appDispVersion = payload.value
  },
  setIsUpdateVersion: (state, payload) => {
    state.isUpdateVersion = payload.value
  },
  checkAppVersionSucc: (state, payload) => {
    state.release.data = payload.value.data
    state.release.status = payload.value.status
  },
  setUpdateProgressPre: (state, payload) => {
    state.updateProgressPre = payload.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
